import React, { useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

function scrollToTop() {
    window.scrollTo(0, 0);
}

function Navbar() {
    const location = useLocation();
    const navbarRef = useRef(null); // ref for the navbar

    const isActive = (path) => location.pathname === path;

    const handleNavLinkClick = () => {
        scrollToTop();
        const navbar = navbarRef.current;
        if (navbar && navbar.classList.contains('in')) {
            navbar.classList.remove('in');
        }
    };

    return (
        <header className="header header_style_01">
            <nav className="megamenu navbar navbar-default">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <button
                            type="button"
                            className="navbar-toggle collapsed"
                            data-toggle="collapse"
                            data-target="#navbar"
                            aria-expanded="false"
                            aria-controls="navbar"
                        >
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                        <Link to="/" className="navbar-brand" onClick={handleNavLinkClick}>
                            {/* <img src="images/logos/logo.png" alt="logo" /> */}

                            {/* <img src="images/apple-touch-icon.png" alt="logo" style={{ width: '100px', height: '77px' }}/> */}

                            <img src="images/logos/enin.jpg" alt="Logo" className="logo" />
                        </Link>
                    </div>

                    <div id="navbar" ref={navbarRef} className="navbar-collapse collapse">
                        <ul className="nav navbar-nav navbar-right">
                            <li className={isActive('/') ? 'active' : ''}>
                                <Link to="/" className={isActive('/') ? 'active' : ''} onClick={handleNavLinkClick}>Home</Link>
                            </li>
                            <li className={isActive('/privacy-policy') ? 'active' : ''}>
                                <Link to="/privacy-policy" className={isActive('/privacy-policy') ? 'active' : ''} onClick={handleNavLinkClick}>Privacy Policy</Link>
                            </li>
                            <li>
                                <a
                                    href="https://web.enin.io/"
                                    className="enin-login"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={handleNavLinkClick}
                                >
                                    enin Login
                                </a>
                            </li>
                            <li className={isActive('/about') ? 'active' : ''}>
                                <Link to="/about" className={isActive('/about') ? 'active' : ''} onClick={handleNavLinkClick}>About us</Link>
                            </li>
                            <li className={isActive('/contact') ? 'active' : ''}>
                                <Link to="/contact" className={isActive('/contact') ? 'active' : ''} onClick={handleNavLinkClick}>Contact us</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Navbar;
